module.exports = __webpack_public_path__ + "static/img/hook.5a389fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rides/peterpan/hook.png
// module id = 16
// module chunks = 0